import React, { memo } from 'react';
import Tippy from '@tippyjs/react';

import { ITooltipProps } from './Tooltip.types';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale-subtle.css';
import './Tooltip.scss';

const Tooltip: React.FC<ITooltipProps> = ({
	children,
	content,
	subContent,
	delay = 0,
	interactive,
	isDisabled = false,
	maxWidth,
	noWordBreak = false,
	offset,
	placement = 'top',
	visible,
}) => (
	<Tippy
		arrow
		content={
			noWordBreak || maxWidth ? (
				<div
					style={{
						width: noWordBreak ? 'max-content' : 'auto',
					}}
				>
					{content}
					{subContent
						&& <div className='f5gTooltipSubContent'>
							{subContent}
						</div>
					}
				</div>
			) : (
				<>
					{content}
					{subContent
						&& <div className='f5gTooltipSubContent'>
							{subContent}
						</div>
					}
				</>
			)
		}
		delay={delay}
		disabled={isDisabled}
		interactive={interactive}
		maxWidth={maxWidth}
		offset={offset}
		placement={placement}
		visible={visible}
	>
		{children}
	</Tippy>
);

export default memo(Tooltip);
